import Axios from 'axios'
import { getAvailableRanges } from '../dummy-data/DUMMYDATA'
import { handleApiError } from './config'

// export function login(email, password) {
//   return new Promise((resolve, reject) => {
//     Axios.post('auth/login', {
//       email: email,
//       password: password
//     })
//       .then((res) => {
//         return resolve(res.data)
//       })
//       .catch((err) => {
//         handleApiError(err)
//         return reject(err)
//       })
//   })
// }

// TODO other endepoints

const DEBUG = true // TODO

const AUTH_ITEM_NAME = process.env.REACT_APP_NAME

export function isAuthenticated() {
  let auth = getAuthentication()

  if (auth != null) {
    if ('token' in auth) 
      return true
    else {
      clearAuthentication()
      return false
    }
  } else {
    return false
  }
  // return auth != null && (auth.token || false)
  // return localStorage.getItem(AUTH_ITEM_NAME) !== null && 
}

export function setAuthentication(auth) {
  // In normal circunstances, the auth object should include information regarding the type of user this is
  // But since we're not yet using a backend, we'll determine that according to the email

  let authObj = {
    name: 'Convidado',
    email: auth.email,
    token: auth.token,
  }

  switch (auth.email) {
    case 'eco.demo.ip@siemens.com':      
      authObj['isReportIssuer'] = true
      authObj['isAdmin'] = true
      authObj['entity'] = 'IP' 
      break
    case 'eco.demo.cp@siemens.com':
      authObj['isReportIssuer'] = false
      authObj['isAdmin'] = false
      authObj['entity'] = 'CP'
      break
    case 'eco.demo.medway@siemens.com':
      authObj['isReportIssuer'] = false
      authObj['isAdmin'] = false
      authObj['entity'] = 'Medway'
      break
  }

  localStorage.setItem(AUTH_ITEM_NAME, JSON.stringify(authObj))
}

export function getAuthentication() {
  return JSON.parse(localStorage.getItem(AUTH_ITEM_NAME))
}

export function clearAuthentication() {
  localStorage.removeItem(AUTH_ITEM_NAME)
}

// export function isAdmin() {
//   return getAuthentication().isAdmin || false
// }

export function isReportIssuer() {
  const auth = getAuthentication()
  return (auth.isReportIssuer || false) || (auth.isAdmin || false)
}

// export function isOperator() {
//   const auth = getAuthentication()
//   return !auth.isAdmin && !auth.isReportIssuer
// }
